import React, {FC, ReactNode} from 'react';
import styled from 'styled-components';

import {Handler} from '../../../libs/shared/helpers/src/react/reactHelpers';
import {Button} from '../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {VisualSizesEnum} from '../../../libs/shared/ui/src/styles/commonStyles';
import {CarouselNavigationButtonVariantsEnum} from './carouselCommon';

/*
 * Props.
 */

interface CarouselNavigationButtonProps {
  variant: CarouselNavigationButtonVariantsEnum;
  onClick: Handler;
  children: ReactNode;
}

/*
 * Style.
 */

const StyledPrimaryButtonContentDiv = styled.div`
  font-size: 20px;
`;

const StyledSubduedLinkButtonContentDiv = styled.div`
  color: ${(p) => p.theme.greys.shade70};
`;

/*
 * Component.
 */

export const CarouselNavigationButton: FC<CarouselNavigationButtonProps> = (props) => {
  const {onClick, variant, children} = props;
  switch (variant) {
    case CarouselNavigationButtonVariantsEnum.PRIMARY:
      return (
        <Button onClick={onClick} size={VisualSizesEnum.LARGE} variant={ButtonVariantsEnum.PRIMARY}>
          <StyledPrimaryButtonContentDiv>{children}</StyledPrimaryButtonContentDiv>
        </Button>
      );
    case CarouselNavigationButtonVariantsEnum.LINK:
      return (
        <Button variant={ButtonVariantsEnum.LINK} size={VisualSizesEnum.MEDIUM} onClick={onClick}>
          {children}
        </Button>
      );
    case CarouselNavigationButtonVariantsEnum.SUBDUED_LINK:
      return (
        <Button onClick={onClick} size={VisualSizesEnum.SMALL} variant={ButtonVariantsEnum.LINK}>
          <StyledSubduedLinkButtonContentDiv>{children}</StyledSubduedLinkButtonContentDiv>
        </Button>
      );
    default:
      return null;
  }
};
